var m = require('mithril');
var prop = require('mithril/stream');
var animations = require('../libs/animations');
var session = require('../auth/models/session');
var io = require('../libs/socketio');

var alerts = require('./components/alerts');
var header = require('./components/header');
var loaders = require('./components/loaders');
var modal = require('./components/modal');
var loadingModal = require('./components/loadingModal');
var downloadReportModal = require('./components/downloadReportModal');
var generatedReportsModal = require('./components/generatedReportsModal');
var equipmentModel = require('../equipment/models/equipment');
var edit = require('./components/edit');
var reportsArray = require('./components/reportsArray');
var measurableModel = require('../measurable/models/measurable');
var idleAutoRefresh = require('./idleAutoRefresh');

var REPORT_STATUS_FLASH_MS = 3000;

function oninit (vnode) {
  var ctrl = this
  ctrl.menuOpen = prop(false);
  ctrl.hideMenu = prop();
  ctrl.notifications = prop([]);
  ctrl.notificationHandlers = [];
  ctrl.lastReportProcessingStatus = '';
  ctrl.reportStatusMessage = '';
  ctrl.reportStatusTone = '';
  ctrl.reportStatusFlashTimer = null;
  
  var hideLayoutMenu = localStorage.getItem('hideLayoutMenu');
  if (hideLayoutMenu === 'true') { ctrl.hideMenu(true); }
  if (hideLayoutMenu === 'false' || !hideLayoutMenu) { ctrl.hideMenu(false); }

  if (typeof activeTab !== 'undefined') {
    header.vm.activeTab(activeTab);
  }

  if (!nrActiveProfile) {
    session.next(m.route.get());
    m.route.set('/login');
    return
  }

  equipmentModel.getClassTree();
  measurableModel.getClassTree();
  reportsArray.start();
  ctrl.stopIdleAutoRefresh = idleAutoRefresh.start();

  this.logout = function () {
    session.logout().then(function () {
      window.location.href = '/#!/login'
    })
  };

};


function debounce(fn, delay) {
  let timer;
  return function() {
    clearTimeout(timer);
    timer = setTimeout(fn, delay);  // Wait for the delay before calling the function
  };
}


function oncreate(vnode) {
  const ctrl = this;

  // Set initial bigScreen state based on innerWidth 
  ctrl.bigScreen = window.innerWidth >= 1135;  // Breakpoint matches Tachyons large breakpoint

  // Store the initial client width for comparison
  let lastClientWidth = document.documentElement.clientWidth;

  // Define the function to check for changes in clientWidth
  const updateBigScreen = function() {
    const clientWidth = document.documentElement.clientWidth;
    const innerWidth = window.innerWidth;

    // Only trigger the evaluation if the clientWidth has changed (ignore scrollbar changes)
    if (clientWidth !== lastClientWidth) {
      lastClientWidth = clientWidth;

      // Now update bigScreen flag based on innerWidth
      const newBigScreen = innerWidth >= 1135;  // Compensate for scrollbar by using slightly lower breakpoint

      // Only trigger redraw if the state actually changes
      if (newBigScreen !== ctrl.bigScreen) {
        ctrl.bigScreen = newBigScreen;
        m.redraw();  // Trigger Mithril redraw if the state changes
      }
    }
  };

  // Debounce the updateBigScreen function for resize events
  ctrl.updateBigScreen = debounce(updateBigScreen, 100);

  // Add resize event listener
  window.addEventListener('resize', ctrl.updateBigScreen);

  // Call initially to set the correct state
  updateBigScreen();

  // Websocket notifications for new events/comments
  const handleCommentCreated = function (payload) {
    var currentUser = session.user();
    if (!isEventNotificationsEnabled(currentUser) || !isUserNotificationEnabled(currentUser, 'commentNotificationsEnabled')) {
      return;
    }
    if (!payload || payload.deleted ) return;
    const userLabel = payload.user ? `${payload.user.firstName || ''} ${payload.user.lastName || ''}`.trim() : '';
    const body = (payload.message || '').toString().trim();
    const trimmedBody = body.length > 80 ? `${body.slice(0, 80)}...` : body;

    let text = userLabel ? `New comment from ${userLabel}` : 'New comment added';
    const detail = trimmedBody ? `: ${trimmedBody}` : '';
    const href = getNotificationHref(payload.subjectRecord);
    const pathNodes = getNotificationPathNodes(payload.subjectRecord);
    addNotification(ctrl, `${text}${detail}`, href, pathNodes);
  };

  const handleCommandCreated = function (payload) {
    var currentUser = session.user();
    if (!isEventNotificationsEnabled(currentUser) || !isUserNotificationEnabled(currentUser, 'commandNotificationsEnabled')) {
      return;
    }
    if (!payload) return;
    if (isNotificationFromCurrentUser(payload, currentUser)) return;
    const properties = payload.properties || {};
    const userInfo = payload.user || properties || {};
    const userLabel = `${userInfo.firstName || ''} ${userInfo.lastName || ''}`.trim();
    const isOverride = payload['@class'] === 'Override' || properties.commandType === 'override';
    const title = isOverride ? 'New override' : 'New command';
    const valueDetail = formatCommandValue(properties.value);
    const activeDetail = typeof properties.active !== 'undefined'
      ? (Number(properties.active) === 1 ? 'Activated' : 'Released')
      : '';
    const detail = valueDetail
      ? `: ${valueDetail}${activeDetail ? ' (' + activeDetail + ')' : ''}`
      : (activeDetail ? `: ${activeDetail}` : '');
    const subjectRecord = {
      '@rid': payload['@rid'],
      '@class': payload['@class'],
      object: payload.object || null
    };
    const href = getNotificationHref(subjectRecord);
    const pathNodes = getNotificationPathNodes(subjectRecord);
    addNotification(ctrl, `${title}${userLabel ? ' from ' + userLabel : ''}${detail}`, href, pathNodes);
  };

  io.on('comment-event', handleCommentCreated);
  ctrl.notificationHandlers.push(['comment-event', handleCommentCreated]);
  io.on('command-event', handleCommandCreated);
  ctrl.notificationHandlers.push(['command-event', handleCommandCreated]);
}

function onremove(vnode) {
  const ctrl = this;
  // Clean up the event listener when the component is removed
  window.removeEventListener('resize', ctrl.updateBigScreen);
  if (ctrl.stopIdleAutoRefresh) ctrl.stopIdleAutoRefresh();
  if (ctrl.reportStatusFlashTimer) clearTimeout(ctrl.reportStatusFlashTimer);
  reportsArray.stop();
  (ctrl.notificationHandlers || []).forEach(([event, handler]) => {
    io.off(event, handler);
  });
}

function getReportProcessingStatus(reportsArray) {
  let status = '';
  reportsArray.forEach(r => {
    if (r.status === 'error' && status !== 'done') status = 'error';
    if (r.status === 'processing') status = 'processing';
    if (r.status === 'done' && status !== 'processing') status = 'done';
  });
  return status;
}

function clearReportStatusFlash(ctrl) {
  if (ctrl.reportStatusFlashTimer) clearTimeout(ctrl.reportStatusFlashTimer);
  ctrl.reportStatusFlashTimer = null;
  ctrl.reportStatusMessage = '';
  ctrl.reportStatusTone = '';
}

function updateReportStatusFlash(ctrl, status) {
  if (status === ctrl.lastReportProcessingStatus) return;
  ctrl.lastReportProcessingStatus = status;

  var messages = {
    processing: 'Creating Report',
    done: 'Report Created',
    error: 'Error Creating Report'
  };
  if (!messages[status]) {
    clearReportStatusFlash(ctrl);
    return;
  }

  if (ctrl.reportStatusFlashTimer) clearTimeout(ctrl.reportStatusFlashTimer);
  ctrl.reportStatusMessage = messages[status];
  ctrl.reportStatusTone = status;
  ctrl.reportStatusFlashTimer = setTimeout(function () {
    clearReportStatusFlash(ctrl);
    m.redraw();
  }, REPORT_STATUS_FLASH_MS);
}

function hasAvailableReport() {
  return reportsArray().some(function (report) {
    return report && report.status === 'done';
  });
}

function reportStatusBackground(ctrl, collapsed) {
  if (ctrl.reportStatusTone === 'error') return 'bg-dark-red';
  if (ctrl.reportStatusTone === 'processing') return 'bg-blue';
  if (ctrl.reportStatusTone === 'done') return 'bg-green';
  return collapsed ? 'bg-near-black' : 'bg-dark-gray';
}

function toggleLayoutMenu(ctrl) {
  const hideLayoutMenu = localStorage.getItem('hideLayoutMenu');
  ctrl.hideMenu(hideLayoutMenu === 'true');
  if (!hideLayoutMenu || hideLayoutMenu === 'false') ctrl.hideMenu(false);
}

function toggleSidebarEdge(ctrl) {
  var nextHidden = !ctrl.hideMenu();
  localStorage.setItem('hideLayoutMenu', nextHidden ? 'true' : 'false');
  ctrl.hideMenu(nextHidden);
}

function canCancelTransferImport() {
  var label = (loaders.transfer.label && loaders.transfer.label && loaders.transfer.label()) || '';
  var endpoint = loaders.transfer.cancelEndpoint && loaders.transfer.cancelEndpoint ? loaders.transfer.cancelEndpoint() : '';
  return /^(importing|cancelling)/i.test(String(label || '')) && !!endpoint;
}

function cancelActiveTransferImport() {
  if (!canCancelTransferImport()) return;
  if (loaders.transfer.canceling && loaders.transfer.canceling && loaders.transfer.canceling()) return;

  var uid = loaders.transfer.jobUid();
  var endpoint = loaders.transfer.cancelEndpoint();
  loaders.transfer.canceling(true);
  if (loaders.transfer.setState) {
    var currentProgress = loaders.transfer.progress && loaders.transfer.progress ? loaders.transfer.progress() : null;
    loaders.transfer.setState('Cancelling', currentProgress);
  }
  m.redraw();

  fetch(endpoint, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(uid ? { uid: uid } : {})
  })
    .catch(function () {})
    .finally(function () {
      loaders.transfer.canceling(false);
      m.redraw();
    });
}

function renderTransferCancelIcon(sizeClass) {
  if (!canCancelTransferImport()) return null;
  var isCanceling = loaders.transfer.canceling && loaders.transfer.canceling && loaders.transfer.canceling();
  return m('a.pointer.flex.items-center.justify-center.ml2', {
    title: isCanceling ? 'Cancelling import...' : 'Cancel import',
    onclick: function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      cancelActiveTransferImport();
    },
    style: {
      width: sizeClass === 'small' ? '1.4rem' : '1.6rem',
      height: sizeClass === 'small' ? '1.4rem' : '1.6rem',
      color: '#ff4136',
      transition: 'opacity 120ms ease',
      opacity: isCanceling ? 0.75 : 1
    }
  }, [
    m('i' + (isCanceling ? '.ion-load-a.spin' : '.ion-close') + (sizeClass === 'small' ? '.f4' : '.f3'))
  ]);
}

function renderMenuButton(ctrl) {
  return m('div.w-100.flex.justify-center.br.b--white', {
    onclick: () => ctrl.menuOpen(!ctrl.menuOpen()),
    style: { transition: 'all 0.2s ease' }
  }, [
    ctrl.menuOpen() ? m('i.ion-close.f-subheadline') : m('i.ion-chevron-up.f-subheadline')
  ]);
}

function renderReportStatusButton(ctrl) {
  if (loaders.transfer.show()) {
    var transferLabel = (loaders.transfer.label && loaders.transfer.label && loaders.transfer.label()) || 'Processing';
    var transferProgress = loaders.transfer.progress && loaders.transfer.progress ? loaders.transfer.progress() : null;
    var transferText = Number.isFinite(Number(transferProgress))
      ? (transferLabel + ' ' + Math.round(Number(transferProgress)) + '%')
      : (transferLabel + '...');
    return m('div.w-20.flex.justify-center', {
      style: { display: 'block' }
    }, [
      m('div.light-gray.h-100.flex.items-center.justify-center.mh2.bg-blue.ph2', { title: transferText }, [
        m('i.f1.ion-load-a.spin'),
        renderTransferCancelIcon('small')
      ])
    ]);
  }
  var available = hasAvailableReport();
  var label = ctrl.reportStatusMessage || 'Downloads';
  var iconClass = available ? 'ion-ios-download' : 'ion-ios-download-outline';
  var iconColor = ctrl.reportStatusTone ? 'dark-gray' : (available ? 'green' : 'light-gray');
  return m('div.w-20.flex.justify-center', {
    style: { display: 'block' }
  }, [
    m('a.h-100.flex.items-center.justify-center.mh2.pointer.' + reportStatusBackground(ctrl, false), {
      title: label,
      onclick: () => generatedReportsModal.vm.open()
    }, [
      m('i.f1.' + iconClass + '.' + iconColor)
    ])
  ]);
}

function getSidebarWidth(ctrl) {
  return ctrl.hideMenu() ? '2.5rem' : '16rem';
}

function renderReportStatus(ctrl) {
  var containerStyle = {
    flex: '0 0 3rem',
    height: '3rem',
    width: getSidebarWidth(ctrl)
  };

  if (loaders.transfer.show()) {
    var transferLabel = (loaders.transfer.label && loaders.transfer.label && loaders.transfer.label()) || 'Processing';
    var transferProgress = loaders.transfer.progress && loaders.transfer.progress ? loaders.transfer.progress() : null;
    var transferText = Number.isFinite(Number(transferProgress))
      ? (transferLabel + ' ' + Math.round(Number(transferProgress)) + '%')
      : (transferLabel + '...');
    return m('div.flex.flex-none.justify-center.bb.b--mid-gray', {
      class: 'bg-blue',
      style: containerStyle,
      id: 'reports-indicator'
    }, [
      m('div.pa2.h-100.flex.items-center.dark-gray', [
        m('i.f1.ion-load-a.spin'),
        m('span.ml2', transferText),
        renderTransferCancelIcon('large')
      ])
    ]);
  }

  var available = hasAvailableReport();
  var label = ctrl.reportStatusMessage || 'Downloads';
  var iconClass = available ? 'ion-ios-download' : 'ion-ios-download-outline';
  var iconColor = ctrl.reportStatusTone ? 'dark-gray' : (available ? 'green' : 'light-gray');
  return m('div.flex.flex-none.justify-center.bb.b--mid-gray.' + reportStatusBackground(ctrl, ctrl.hideMenu()), {
    style: containerStyle,
    id: 'reports-indicator'
  }, [
    m('a.w-100.h-100.flex.items-center.justify-center.pointer', {
      title: label,
      onclick: () => generatedReportsModal.vm.open()
    }, [
      m('i.f1.' + iconClass + '.' + iconColor),
      ctrl.hideMenu() ? null : m('span.ml2.light-gray', label)
    ])
  ]);
}

function addNotification(ctrl, message, href, pathNodes) {
  if (!message) return;
  const id = Date.now() + Math.random();
  const current = ctrl.notifications();
  ctrl.notifications([{ id, message, href, pathNodes }, ...current]);
  m.redraw();
  setTimeout(() => {
    ctrl.notifications(ctrl.notifications().filter(n => n.id !== id));
    m.redraw();
  }, 10000);
}

function getNotificationHref(subjectRecord) {
  if (!subjectRecord || !subjectRecord['@rid'] || !subjectRecord['@class']) return null;
  if (subjectRecord['@class'] === 'Incident') {
    const point = subjectRecord.out_Of && subjectRecord.out_Of[0] && subjectRecord.out_Of[0].in;
    if (point && point['@rid']) {
      return `#/point/${point['@rid'].slice(1)}`;
    }
    return null;
  }
  return `#/equipment/${subjectRecord['@class']}/${subjectRecord['@rid'].slice(1)}`;
}

function formatCommandValue(value) {
  if (typeof value === 'undefined' || value === null || value === '') return '';
  if (Array.isArray(value)) {
    return value.map(function (entry) {
      var num = parseFloat(entry);
      return Number.isNaN(num) ? String(entry) : num.toFixed(2);
    }).join(', ');
  }
  var numeric = parseFloat(value);
  return Number.isNaN(numeric) ? String(value) : numeric.toFixed(2);
}

function normalizeBoolean(value, fallback) {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value === 1;
  if (typeof value === 'string') {
    var trimmed = value.trim().toLowerCase();
    if (['true', '1', 'yes', 'on'].indexOf(trimmed) !== -1) return true;
    if (['false', '0', 'no', 'off'].indexOf(trimmed) !== -1) return false;
  }
  return fallback;
}

function isEventNotificationsEnabled(user) {
  if (!user) return true;
  return normalizeBoolean(user.eventNotificationsEnabled, true);
}

function isUserNotificationEnabled(user, key) {
  if (!user) return true;
  return normalizeBoolean(user[key], true);
}

function normalizeRid(value) {
  if (!value) return '';
  return String(value).replace(/^#/, '');
}

function isNotificationFromCurrentUser(payload, currentUser) {
  const currentUserRid = normalizeRid(currentUser && currentUser['@rid']);
  if (!currentUserRid || !payload) return false;

  const properties = payload.properties || {};
  const userInfo = payload.user || {};
  let actorRid = normalizeRid(userInfo['@rid'] || userInfo.rid || properties['@rid'] || properties.rid);

  if (!actorRid && typeof payload.user === 'string') {
    actorRid = normalizeRid(payload.user);
  }

  return actorRid === currentUserRid;
}

function formatNotificationPathNodeLabel(node) {
  if (!node) return '';
  const nodeClass = node.class || node['@class'] || '';
  const nodeName = node.name || '';
  if (nodeName === 'root') return 'Home';
  if (nodeClass === 'Room' && node.roomNumber) {
    return `${nodeName} ${node.roomNumber}`.trim();
  }
  return nodeName || nodeClass || '';
}

function getNotificationPathNodeHref(node) {
  if (!node) return '';
  if (node.name === 'root') return '/location';
  const rid = normalizeRid(node.rid || node['@rid']);
  if (!rid) return '';
  const nodeClass = node.class || node['@class'] || '';
  if (nodeClass === 'Dashboard') return '/dashboard/' + rid;
  if (nodeClass === 'System') return '/system/' + rid;
  if (['Site', 'Building', 'Level', 'Room'].includes(nodeClass)) {
    return '/location/' + rid;
  }
  if (nodeClass === 'Point') return '/point/' + rid;
  if (nodeClass) {
    return '/equipment/' + nodeClass.toLowerCase() + '/' + rid;
  }
  return '';
}

function getNotificationPathNodes(subjectRecord) {
  if (!subjectRecord) return [];
  const subjectPath = Array.isArray(subjectRecord.path) ? subjectRecord.path : [];
  const objectPath = subjectRecord.object && Array.isArray(subjectRecord.object.path)
    ? subjectRecord.object.path
    : [];
  const pathNodes = subjectPath.length ? subjectPath : objectPath;
  if (!pathNodes.length) return [];
  return pathNodes.map(function (node) {
    return {
      label: formatNotificationPathNodeLabel(node),
      href: getNotificationPathNodeHref(node)
    };
  }).filter(function (node) {
    return Boolean(node && node.label);
  });
}

function removeNotification(ctrl, id) {
  if (!id) return;
  ctrl.notifications(ctrl.notifications().filter(n => n.id !== id));
  m.redraw();
}

function renderNotifications(ctrl) {
  const items = ctrl.notifications();
  if (!items || !items.length) return null;

  return m('div.fixed.top-1.mh3.right-0', {
    style: {
      zIndex: 2001,
    }
  }, items.map(n =>
    m('div.bg-near-black.white.br2.pa3.mv2.shadow-4.flex.items-start.pointer', {
      key: n.id,
      style: { minWidth: '16rem', maxWidth: '24rem' },
      onclick: function () {
        removeNotification(ctrl, n.id);
      }
    }, [
      m('i.ion-android-chat.f3.blue.mr2'),
      m('div.flex-auto', [
        m('div.f5.white', n.message),
        (function () {
          const nodes = Array.isArray(n.pathNodes) ? n.pathNodes : [];
          if (!nodes.length) return m('div.f7.white-70.mt1', 'No path');
          return m('div.f7.mt1', nodes.map(function (node, idx) {
            const content = node.href
              ? m(m.route.Link, { class: 'blue dim', href: node.href }, node.label)
              : node.label;
            return m('span', [
              content,
              idx < nodes.length - 1 ? ' / ' : ''
            ]);
          }));
        })()
      ]),
      m('i.ion-close.f4.blue.ml2.mt1')
    ])
  ));
}


function renderEditButton(ctrl) {
  if (ctrl.menuOpen()) {
    return m('div.w-20.flex.justify-center.bl.b--white', {
      style: { display: session.user().isSuperuser == 1 ? 'block': 'none' },
      onclick: (evt) => {
        edit.vm.toggle(evt);
        ctrl.menuOpen(!ctrl.menuOpen());
      }
    }, [
        m('a.light-gray.flex.justify-center', [
          m('i.f-subheadline', { class: edit.vm.editing() ? 'ion-ios-compose' : 'ion-ios-compose-outline' })
        ])
    ]);
  }
  return null;
}

function renderSidebarToggleButton(ctrl) {
  return m('div.flex.flex-none.justify-center.bt.bb.b--mid-gray' + (ctrl.hideMenu() ? '.bg-near-black' : '.bg-dark-gray'), {
    style: {
      flex: '0 0 2.25rem',
      height: '2.25rem',
      width: '100%'
    }
  }, [
    m('button.button-reset.w-100.h-100.light-gray.pointer.flex.items-center.justify-center', {
      type: 'button',
      title: ctrl.hideMenu() ? 'Expand sidebar' : 'Collapse sidebar',
      onclick: function (event) {
        if (event && typeof event.preventDefault === 'function') event.preventDefault();
        if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
        toggleSidebarEdge(ctrl);
      },
      style: {
        appearance: 'none',
        backgroundColor: 'transparent',
        border: '0',
        boxShadow: 'none',
        color: '#f4f4f4',
        outline: '0',
        padding: '0'
      }
    }, [
      ctrl.hideMenu()
        ? m('i.f3.lh-solid.ion-android-arrow-forward')
        : m('i.f3.lh-solid.ion-android-arrow-back')
    ])
  ]);
}

function renderSidebar(ctrl) {
  return [
    m('div.sidebar.fixed.left-0.top-0.bottom-0.bg-near-black.br' + (ctrl.hideMenu() ? '' : '.w5') + '.overflow-hidden.flex.flex-column', {
      style: ctrl.hideMenu() ? { width: getSidebarWidth(ctrl) } : {}
    }, [
      m('div.sidebar-scroll.flex-auto.overflow-x-hidden.overflow-y-auto', [
        ctrl.hideMenu() 
          ? header.renderCondensedSidebar()
          : m(header, { hideMenu: ctrl.hideMenu() })
      ]),

      m('div.flex.flex-column.flex-none', [
        renderSidebarToggleButton(ctrl),
        renderReportStatus(ctrl),
        session.user().isSuperuser == "1" && m('div.flex-none' + (ctrl.hideMenu() ? '.bg-near-black' : '.bg-dark-gray'), {
          style: {
            flex: '0 0 3rem',
            width: '100%',
            height: '3rem',
          },
          onclick: edit.vm.toggle
          }, 
          m('a.light-gray.w-100.h-100.flex.items-center.justify-center' , [
            ctrl.hideMenu()
            ? m('i.f1', {
                class: edit.vm.editing() ? 'ion-ios-compose' : 'ion-ios-compose-outline',
                style: { transform: 'translateX(0.16rem)' }
              })
            : m('span', [
                m('i.f1.mr2', { class: edit.vm.editing() ? 'ion-ios-compose' : 'ion-ios-compose-outline' }),
                m('span', 'Edit Mode ' + (edit.vm.editing() ? 'On' : 'Off'))
              ])
          ])
        )
      ])
    ])
  ];
}

function renderMainContent(ctrl, vnode) {
  return m('div.mt3.pb5' + (ctrl.hideMenu() ? '' : '.sidebar-margin'), {
    style: ctrl.hideMenu() ? { marginLeft: getSidebarWidth(ctrl) } : {}
  }, [
    isPointRoute() ? null : m('div', { class: 'alerts' }, m(alerts)),
    vnode.children // Main content
  ]);
}

function isPointRoute() {
  return /^\/point\//.test(m.route.get().split('?')[0]);
}

function renderSlideUpMenu(ctrl) {
  return m('div.fixed.w-100.bg-near-black.pb4', {
    style: {
      transition: 'transform 0.2s ease',
      transform: ctrl.menuOpen() ? 'translateY(0)' : 'translateY(100%)',
    }
  }, [
    // Menu content
    m('div', [
      m('div', { style: { height: '100vh', overflow: 'scroll' } }, m(header))
    ])
  ]);
}

function view(vnode) {
  const ctrl = this;
  toggleLayoutMenu(ctrl);

  ctrl.reportProcessingStatus = getReportProcessingStatus(reportsArray());
  updateReportStatusFlash(ctrl, ctrl.reportProcessingStatus);
  
  return m('div', [
    m(modal),
    m(loadingModal),
    m(downloadReportModal, { reportsArray: reportsArray }),
    m(generatedReportsModal, { reportsArray: reportsArray }),

    // Bottom fixed menu (mobile view)
    ctrl.bigScreen ? null : m('div.fixed.bottom-0.w-100.flex.pv3.bg-near-black', { style: { zIndex: 10000 } }, [
      renderMenuButton(ctrl),
      renderReportStatusButton(ctrl),
      renderEditButton(ctrl)
    ]),

    renderNotifications(ctrl),

    ctrl.bigScreen ? null : renderSlideUpMenu(ctrl),

    m(`div.bg-dark-gray${!ctrl.bigScreen && ctrl.menuOpen() ? '.dn' : ''}`, { oncreate: animations.fadesIn }, [
      ctrl.bigScreen
      ?
      renderSidebar(ctrl)
      :
      m("div", { style: { visibility: loaders.main.show() ? 'visible' : 'hidden', opacity: 0.25 } }, [
        m('img.loading', { src: '/images/loading-bars.svg' })
      ]),
      renderMainContent(ctrl, vnode)
    ])
  ]);
}

module.exports = {oninit, oncreate, onremove, view};
